import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leeds-termos',
  templateUrl: './leeds-termos.component.html',
  styleUrls: ['./leeds-termos.component.css']
})
export class LeedsTermosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
